/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Confirm_ReplaceInputs */

const vi_chot_so_confirm_replace = /** @type {(inputs: Chot_So_Confirm_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay đã có phiếu chờ duyệt. Chốt lại sẽ thay thế phiếu cũ. Tiếp tục?`)
};

/**

* @param {Chot_So_Confirm_ReplaceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_confirm_replace = /** @type {((inputs?: Chot_So_Confirm_ReplaceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Confirm_ReplaceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_confirm_replace(inputs)
});